if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				// Keep the adaptive gallery height in sync when slides use different aspect ratios.
				// On touch devices the active slide can change while momentum scrolling is still running,
				// so the final height is based on the slide closest to the settled scroll position.
				let productGalleryHeightTimer;
				const syncProductGalleryHeight = (delay = 0) => {
					clearTimeout(productGalleryHeightTimer);
					productGalleryHeightTimer = setTimeout(() => {
						if ( ! this.productSlider.sliderEnabled || ! this.productSlider.o.autoHeight ) return;

						const holder = this.productSlider.element;
						const viewport = this.productSlider.viewport;
						const slides = Array.from(this.productSlider.indexedItems || []);
						if ( ! holder || ! viewport || ! slides.length ) return;

						const slide = slides.reduce((closest, candidate) => {
							return Math.abs(candidate.offsetLeft - holder.scrollLeft) < Math.abs(closest.offsetLeft - holder.scrollLeft)
								? candidate
								: closest;
						}, slides[0]);

						const applyHeight = () => {
							const ratio = parseFloat(slide.dataset.ratio);
							const width = slide.getBoundingClientRect().width;
							const measuredHeight = slide.getBoundingClientRect().height;
							const ratioHeight = ratio > 0 && width > 0 ? width / ratio : 0;
							const height = Math.max(measuredHeight, ratioHeight);

							if ( height > 0 ) viewport.style.height = Math.ceil(height) + 'px';
						};

						requestAnimationFrame(() => requestAnimationFrame(applyHeight));
					}, delay);
				};

				this.productSlider.addEventListener('ready', () => syncProductGalleryHeight());
				this.productSlider.addEventListener('change', () => syncProductGalleryHeight(80));
				this.productSlider.addEventListener('scroll', () => syncProductGalleryHeight(140));

				const productGalleryHolder = this.productSlider.querySelector('.css-slider-holder');
				if ( productGalleryHolder ) {
					productGalleryHolder.addEventListener('scroll', () => syncProductGalleryHeight(140), { passive: true });
					productGalleryHolder.addEventListener('touchend', () => syncProductGalleryHeight(80), { passive: true });
				}

				this.productSlider.querySelectorAll('.product-gallery-item img').forEach(image => {
					if ( ! image.complete ) image.addEventListener('load', () => syncProductGalleryHeight(), { once: true });
				});

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i === 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.#thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.#thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType === 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax === 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action === 'overlay' || KROWN.settings.cart_action === 'popup' ) ) {
				
				let addToCartEnter = false;

				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode === window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {

					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{

						/* ==========================================================
						   DOÑA TOMASA - AVISO PRODUCTO AÑADIDO AL CARRITO
						   Aviso centrado, sin abrir el carrito lateral.
						   ========================================================== */

						let cartToast = document.getElementById('dt-cart-toast');

						if ( ! cartToast ) {

							cartToast = document.createElement('div');
							cartToast.id = 'dt-cart-toast';

							cartToast.setAttribute('role', 'status');
							cartToast.setAttribute('aria-live', 'polite');

							cartToast.textContent = 'Producto añadido al carrito';

							Object.assign(cartToast.style, {
								position: 'fixed',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
								zIndex: '999999',

								padding: '16px 28px',

								background: '#ffffff',
								color: '#222222',

								border: '2px solid #000000',
								borderRadius: '10px',

								boxShadow: '0 8px 24px rgba(0,0,0,.18)',

								fontSize: '16px',
								fontWeight: '600',
								lineHeight: '1.3',
								textAlign: 'center',

								minWidth: '300px',
								maxWidth: '90vw',

								opacity: '0',
								visibility: 'hidden',
								pointerEvents: 'none',

								transition: 'opacity .2s ease'
							});

							document.body.appendChild(cartToast);
						}

						clearTimeout(window.dtCartToastTimer);

						cartToast.style.visibility = 'visible';
						cartToast.style.opacity = '1';

						window.dtCartToastTimer = setTimeout(() => {

							cartToast.style.opacity = '0';

							setTimeout(() => {
								cartToast.style.visibility = 'hidden';
							}, 200);

						}, 1000);

						/* FIN - DOÑA TOMASA - AVISO PRODUCTO AÑADIDO AL CARRITO */

						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}

						addToCartEnter = false;

					});

				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');

			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');

			if ( addToCartButton ) {

				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}

				const buyObserver = new MutationObserver(()=>{

					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}

				});

				buyObserver.observe(addToCartButton,{
					attributes: true,
					childList: false,
					subtree: false
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('dt-product-variants[data-main-product-variants]');

			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		#thumbnailNavigationHelper(index=0){

			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{

				if ( i === index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');

			});

		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;

			if ( variant ) {
				
				// image handling

				if ( variant.featured_media && variant.featured_media.id ) {

					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');

					if ( variantImg ) {

						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {

							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}

						} else {

							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});

						}

					}

				}

			}

		}

	}

	if ( typeof customElements.get('product-page') === 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}